export class LeadtoolsResourceHelper {
  static getResources() {
    const resources = new lt.Annotations.Engine.AnnResources();
    const rubberStampsResources = resources.rubberStamps;
    const imagesResources = resources.images;

    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampApproved
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/approved.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampAssigned
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Assigned.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampClient
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Client.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampChecked
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/checked.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampCopy
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Copy.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampDraft
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Draft.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampExtended
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Extended.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampFax
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Fax.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampFaxed
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Faxed.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampImportant
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Important.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampInvoice
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Invoice.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampNotice
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Notice.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampPaid
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Paid.png'
    );

    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampOfficial
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Official.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampOnFile
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Onfile.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampPassed
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Passed.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampPending
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Pending.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampProcessed
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Processed.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampReceived
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Received.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampRejected
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/rejected.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampRelease
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Release.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampSent
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Sent.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampShipped
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/Shipped.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampTopSecret
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/topsecret.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampUrgent
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/urgent.png'
    );
    rubberStampsResources[
      lt.Annotations.Engine.AnnRubberStampType.stampVoid
      ] = new lt.Annotations.Engine.AnnPicture(
      'resources/objects/RubberStamps/void.png'
    );

    imagesResources.push(
      new lt.Annotations.Engine.AnnPicture('resources/objects/Point.png')
    );
    imagesResources.push(
      new lt.Annotations.Engine.AnnPicture('resources/objects/lock.png')
    );
    imagesResources.push(
      new lt.Annotations.Engine.AnnPicture('resources/objects/hotspot.png')
    );

    return resources;
  }
}
